module.exports = __webpack_public_path__ + "static/media/logo.3cc800d4.png";